@if (variant() === 'center') {
  <div class="center-wrapper">
    @if (skinName()) {
      <p class="items-info__skin-name">{{ skinName() }}</p>
    }

    <span class="items-info__label">{{ skins().length }} {{ label() }}</span>
  </div>
}

<div class="items-info" [class.items-info--center]="variant() === 'center'">
  @if (showPrice()) {
    <div class="items-info__details">
      <span class="items-info__price-value">
        <app-balance-icon [balance]="sessionService.balanceType()" size="18"/>
        {{ price() | number:'1.2-2' }}
      </span>
      <span class="items-info__label">{{ skins().length }} {{ label() }}</span>
    </div>
  }
  <div class="items-info__thumbnails">
    @for (skin of displayedSkins(); track skin.assetid) {
      <div class="items-info__thumbnail">
        <app-thumbnail-glow-svg [color]="skin.color"/>
        <img [src]="skin.image" [alt]="skin.name"/>
      </div>
    }
    @if (extraCount() > 0) {
      <div class="items-info__thumbnail items-info__thumbnail--more items-info__thumbnail--desktop">
        +{{ extraCount() }}
      </div>
    }
    @if (mobileExtraCount() > 0) {
      <div class="items-info__thumbnail items-info__thumbnail--more items-info__thumbnail--mobile">
        +{{ mobileExtraCount() }}
      </div>
    }
  </div>
</div>
